import script from "./EventBase.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventBase.vue?vue&type=script&lang=ts&setup=true"

import "./EventBase.vue?vue&type=style&index=0&id=ff535956&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff535956"]])

export default __exports__